import type { RegionalFactorInput } from '../../api';

const decimal = (s: string): number => Number(s.trim().replace(/\./g, '').replace(',', '.'));

/** Pasted rows "Bereich;Kreis;Faktor" (header optional), tab or semicolon separated. */
export function parseFactors(text: string, defaults: { source: string; edition: string; license: string }): { rows: RegionalFactorInput[]; bad: number[] } {
  const rows: RegionalFactorInput[] = [];
  const bad: number[] = [];
  text.split(/\r?\n/).forEach((line, i) => {
    if (!line.trim()) return;
    const cells = line.split(/\t|;/).map((c) => c.trim());
    if (i === 0 && /faktor/i.test(line)) return;
    const [area, district, f] = cells.length >= 3 ? cells : ['Deutschland', cells[0] ?? '', cells[1] ?? ''];
    const factor = decimal(f ?? '');
    if (!district || !Number.isFinite(factor) || factor <= 0) { bad.push(i + 1); return; }
    rows.push({ source: defaults.source.trim() || 'BKI', edition: defaults.edition.trim() || null, area: area || 'Deutschland', district, factor, license: defaults.license.trim() || null });
  });
  return { rows, bad };
}

